




























































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import IndustryDto from '@/models/Industries/IndustryDto'
import GiganautVue from '@/components/Shared/GiganautVue';
import IndustryCreate from '@/components/Industries/IndustryCreate.vue';
import IndustryEdit from '@/components/Industries/IndustryEdit.vue';

@Component({
  name: 'Industries',
  components: { IndustryCreate, IndustryEdit }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentIndustry(null);
    }

    async updateCurrentIndustry(industry: IndustryDto) {
        AgencySettingsModule.updateCurrentIndustry(industry);
    }

    get currentIndustry() {
        return AgencySettingsModule.currentIndustry;
    }

    get loadingIndustries() {
        return AgencySettingsModule.loadingIndustries;
    }

    get industries() {
        return AgencySettingsModule.industries;
    }
}
